import { render, staticRenderFns } from "./Stisfaction.vue?vue&type=template&id=52d8f3dd&scoped=true&"
import script from "./Stisfaction.vue?vue&type=script&lang=js&"
export * from "./Stisfaction.vue?vue&type=script&lang=js&"
import style0 from "./Stisfaction.vue?vue&type=style&index=0&id=52d8f3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8f3dd",
  null
  
)

export default component.exports